import resources from './resources';

export const config = {
  interpolation: { escapeValue: false }, // React already does escaping
  lng: import.meta.env.VITE_LANGUAGE || 'en',
  resources,
};

export { resources };
